<ul class="nav nav-tabs" [class]="'nav-tabs-mode-'+dataColor">
    <ng-container *ngFor="let menuItem of menuItems">
        <ng-container *ngIf="menuItem.submenus.length > 0">
            <ng-container *ngFor="let submenuItem of menuItem.submenus">
                <li routerLinkActive="active"><a [routerLink]="submenuItem.code">{{submenuItem.name}}</a></li>
            </ng-container>
        </ng-container>
    </ng-container>
</ul>
